import React from 'react';
import {
  Icon,
  ParagraphText,
  Box,
  StackLayout,
  UtilityText,
} from '@leagueplatform/genesis-core';
import { ObservabilityErrorBoundary } from '@leagueplatform/observability';
import { useIntl } from '@leagueplatform/locales';

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

export function ErrorBoundaryWrapper({ children }: ErrorBoundaryProps) {
  const [error, setError] = React.useState<Error | null>(null);
  const childName =
    React.isValidElement(children) && typeof children.type === 'function'
      ? children.type.name
      : 'Unknown';
  const { formatMessage } = useIntl();

  const errorTitle = childName
    ? formatMessage({ id: 'ERROR_IN_CHILD' }, { childName })
    : formatMessage({ id: 'ERROR' });

  return (
    <ObservabilityErrorBoundary
      onError={(err: Error) => setError(err)}
      fallback={
        <StackLayout
          orientation="horizontal"
          css={{
            border: '$borderWidths$thin solid $criticalBorderDefault',
            borderRadius: '$small',
            backgroundColor: '$criticalBackgroundSubdued',
            padding: '$half',
          }}
        >
          <Icon icon="statusErrorStatusFilled" tint="$criticalIcon" />
          <Box css={{ marginInlineStart: '$half' }}>
            <UtilityText as="p" emphasis="emphasized">
              {errorTitle}
            </UtilityText>
            {error?.message && <ParagraphText>{error.message}</ParagraphText>}
            <ParagraphText>
              {formatMessage({ id: 'ERROR_WRAPPER_MESSAGE' })}
            </ParagraphText>
          </Box>
        </StackLayout>
      }
    >
      {children}
    </ObservabilityErrorBoundary>
  );
}
